
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <Container className="my-5">
      <Row>
        <Col>
          <h1 className="text-center mb-4">About LionShield</h1>
          <p className="lead text-center">
            Founded on the principles of integrity, discretion, and unparalleled client service, LionShield Private Bank is a sanctuary for your wealth.
          </p>
          <p>
            We serve a select group of individuals and families, providing them with a level of personalized financial stewardship that is rare in today's world. Our commitment is to you, our client. We measure our success by your success, and we are dedicated to building a partnership that lasts for generations.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
